export default __webpack_public_path__ + "static/media/logo.041c5d28.png";